export function initAniDebug(){

    const aniDebug = new URLSearchParams(location.search).has('ani');
if(aniDebug) document.documentElement.classList.add('ani-debug');

if(aniDebug){
  const log = (t, el) => console.debug(`[ani] ${t}`, el);
  document.addEventListener('ani:inview-enter', e => log('enter', e.target), true);
  document.addEventListener('ani:inview-exit',  e => log('exit',  e.target),  true);
  document.addEventListener('ani:dominant-change', e => log('dominant', e.detail?.section), true);
}


}


